import { getPermissionsFromToken } from '../../utils/auth';

const state = {
  permissions: getPermissionsFromToken(), // hydrate from stored token on page load
};

const getters = {
  hasPermission: (state) => (permission) => {
    return state.permissions.includes(permission);
  },
};

const mutations = {
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  CLEAR_PERMISSIONS(state) {
    state.permissions = [];
  },
};

const actions = {
  loadPermissions({ commit }) {
    const permissions = getPermissionsFromToken();
    commit('SET_PERMISSIONS', permissions);
  },
  clearPermissions({ commit }) {
    commit('CLEAR_PERMISSIONS');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
